/** @jsxImportSource @emotion/react */
import React, { FC, useState } from 'react';
import { Modal } from '@mui/material';
import { Z_INDEX } from '../../constants/zIndex';
import { carouselStyles } from './location-images-carousel.styles';

type PropTypes = {
    images?: string[];
};

export const LocationImagesCarousel: FC<PropTypes> = ({ images }) => {
    const [selectedImage, setSelectedImage] = useState<string | null>(null);

    if (!images || images.length === 0) {
        return null;
    }

    const handleImageClick = (image: string) => {
        setSelectedImage(image);
    };

    const handleClosePreview = () => {
        setSelectedImage(null);
    };

    return (
        <>
            <div css={carouselStyles.container}>
                {images.map((image, index) => (
                    <div
                        key={index}
                        css={carouselStyles.imageWrapper}
                        onClick={() => handleImageClick(image)}>
                        <img css={carouselStyles.image} src={image} alt={`Location ${index + 1}`} />
                    </div>
                ))}
            </div>
            <Modal
                open={!!selectedImage}
                onClose={handleClosePreview}
                sx={{ zIndex: Z_INDEX.IMAGE_PREVIEW }}>
                <div css={carouselStyles.previewOverlay} onClick={handleClosePreview}>
                    <div css={carouselStyles.previewContent} onClick={e => e.stopPropagation()}>
                        {selectedImage ? (
                            <img
                                css={carouselStyles.previewImage}
                                src={selectedImage}
                                alt="Preview"
                                onClick={handleClosePreview}
                            />
                        ) : null}
                    </div>
                </div>
            </Modal>
        </>
    );
};
